import type { Schedule } from "src/types";

export const getUniqueScheduleTags = (schedules: Schedule[] = []) => {
  const tags = schedules
    .map((scheduleByDate) =>
      (scheduleByDate.schedules || []).flatMap((scheduleItem) =>
        (scheduleItem.tags || []).map((tag) => tag.name)
      )
    )
    .flat();
  return Array.from(new Set(tags));
};
